import { highlightMockups } from '../data/landingPageData';
import Icon from './Icon';
import PhoneMockup from './PhoneMockup';
import './HighlightSection.css';

function HighlightSection() {
  return (
    <section className="highlight-section">
      <div className="highlight-copy">
        <span className="eyebrow">The heart of crumbs</span>
        <h2>Dumps on Sunday</h2>
        <p>One weekly dump. All the little things that made up your week.</p>
      </div>
      <div className="highlight-list">
        <div>
          <Icon name="calendar" />
          <p>A simple weekly ritual that keeps you close.</p>
        </div>
        <div>
          <Icon name="heart" />
          <p>
            <strong>Gentle proof you still think of each other.</strong>
          </p>
        </div>
        <div>
          <Icon name="chat" />
          <p>Reactions and comments that make it personal.</p>
        </div>
      </div>
      <div className="highlight-phones">
        {highlightMockups.map((mockup) => (
          <PhoneMockup variant={mockup.phone} tilt={mockup.tilt} key={mockup.phone} />
        ))}
      </div>
    </section>
  );
}

export default HighlightSection;
